export default "__VITE_ASSET__DyNL2rVs__"